var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 20,
    viewBox: "0 0 39 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2225_5235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45589 4.03117C3.44562 2.46843 4.61628 0.0408075 7.49407 0.00739996C10.3719 -0.0260076 31.9239 0.0408175 31.9239 0.0408175C31.9239 0.0408175 3.83579 15.6867 2.36902 16.4885C0.902257 17.2903 0.358816 20.0334 3.65469 20C6.95056 19.9666 27.8755 20 27.8755 20L5.45589 4.03117Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67179 5.80176L0 9.92202L6.05521 14.3281L7.67179 5.80176Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8832 5.67188L32.3735 5.80179L24.4613 10.0483L30.6663 14.3913L20.1133 14.1982L21.8832 5.67188Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1094 9.95176L33.6314 5.70528L35.6312 5.67188L27.8793 9.92206L33.8439 14.3578H32.0426L26.1094 9.95176Z",
    fill: "#F39800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4053 9.95176L36.9307 5.67188L39.0002 5.73498L31.0846 10.0149L37.2304 14.3913L35.1922 14.3578L29.4053 9.95176Z",
    fill: "#FFE071"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2225_5235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.18fdcebc2bac50d39bab127ddd977cea.svg";
export { ForwardRef as ReactComponent };